import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { UsuarioRequest, Response } from './Types';

class UsuarioController {
  public static async Listar(request: UsuarioRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/usuario/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(UsuarioId: number): Promise<Response> {
    try {
      const response = await Api.get(`api/usuario/ListarUnico/${UsuarioId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  /** O usuário cadastra a senha dele, no primeiro acesso. */
  public static async TrocarSenha(novaSenha: string, confirmacao: string): Promise<Response> {
    try {
      const response = await Api.post('api/usuario/TrocarSenha', {
        NovaSenha: novaSenha,
        Confirmacao: confirmacao,
      });
      return { StatusCode: response.status, Data: response?.data };
    } catch (error: any) {
      const corpo = error?.response?.data;
      return {
        StatusCode: error?.response?.status,
        Data:
          corpo?.ErroDetalhado ||
          corpo?.Erro ||
          (typeof corpo === 'string' ? corpo : null) ||
          ErrorDictionary(error?.response?.status),
      };
    }
  }

  /** O administrador gera uma senha temporária nova e a envia por e-mail. */
  public static async RedefinirSenha(usuarioId: number): Promise<Response> {
    try {
      const response = await Api.post(`api/usuario/RedefinirSenha/${usuarioId}`, {});
      return { StatusCode: response.status, Data: response?.data };
    } catch (error: any) {
      const corpo = error?.response?.data;
      return {
        StatusCode: error?.response?.status,
        Data:
          corpo?.ErroDetalhado ||
          corpo?.Erro ||
          (typeof corpo === 'string' ? corpo : null) ||
          ErrorDictionary(error?.response?.status),
      };
    }
  }

  /** Quantas licenças foram contratadas e quantas estão em uso. Só leitura. */
  public static async Licencas(): Promise<Response> {
    try {
      const response = await Api.get('api/usuario/Licencas');
      return { StatusCode: response.status, Data: response?.data };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
    }
  }

  public static async Adicionar(request: UsuarioRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/usuario/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      /* [22/10] A recusa da procedure chega INTEIRA. É ela que diz "já existe um usuário
         com este login", "o e-mail informado não é válido" ou "limite de licenças
         contratado atingido" - cada uma apontando o que fazer a seguir. O texto genérico
         do ErrorDictionary só entra quando não há mensagem nenhuma. */
      const corpo = error?.response?.data;
      const mensagem =
        corpo?.ErroDetalhado ||
        corpo?.Erro ||
        (typeof corpo === 'string' ? corpo : null) ||
        ErrorDictionary(error?.response?.status);

      return { StatusCode: error?.response?.status, Data: mensagem };
    }
  }

  public static async Atualizar(request: UsuarioRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/usuario/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(usu_id: number): Promise<Response> {
    try {      
       console.log('Excluir Controller: ', usu_id);
      const response = await Api.put(`api/usuario/Excluir`, usu_id);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default UsuarioController;
